(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 78367:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(13275);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
;// CONCATENATED MODULE: ./src/landingPage/datasets/forms/contact.js
var contact = {
    label: "Please fill out this form and we'll get back to you shortly:",
    header: "Contact us",
    headerColor: "#8B80CD",
    fields: [
        {
            label: "Full name",
            id: "full_name",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Business Email",
            id: "email",
            type: "email",
            component: "input",
            required: true
        },
        {
            label: "Company",
            id: "company",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Role (optional)",
            id: "role",
            type: "text",
            component: "input",
            required: false
        },
        {
            label: "How can Demyst help you?",
            id: "message",
            component: "textarea",
            required: false
        }, 
    ],
    form: {
        button_text: "Submit",
        consent: {
            beginning: "I agree to Demyst's ",
            link1_text: "Terms and Conditions",
            link1_url: "/terms-and-conditions",
            separator: " and ",
            link2_text: "Privacy Policy.",
            link2_url: "/privacy-policy"
        }
    },
    errors: {
        field_required: "This field is required!",
        incorrect_mail: "This email address is incorrect."
    }
};

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/Button.jsx
var Button = __webpack_require__(88749);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(17609);
// EXTERNAL MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx + 7 modules
var StandardField = __webpack_require__(24606);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/ContactForm.jsx





var ContactForm = function(param) {
    var data = param.data, formData = param.formData, changeData = param.changeData, errors = param.errors, consent = param.consent, changeConsent = param.changeConsent, handleSubmit = param.handleSubmit, sending = param.sending, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("contact_form-background", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "contact_form-main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "contact_form-header",
                    children: data.header
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "contact_form-label",
                    children: data.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                                fields: data.fields,
                                formData: formData,
                                changeData: changeData,
                                errors: errors
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                id: "consent"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsCheckbox/* TermsCheckbox */.H, {
                                text: data.form.consent,
                                checked: consent,
                                onChange: changeConsent,
                                error: errors.consent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    demystIcon: true,
                                    variant: "secondary",
                                    disabled: sending,
                                    children: data.form.button_text
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/InfoBox.jsx + 3 modules
var InfoBox = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingSourceCarousel.jsx
var LandingSourceCarousel = __webpack_require__(96615);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/DiscoveryFormTemplate.jsx















var DiscoveryForm = function(param) {
    var data = param.data, type = param.type, className = param.className;
    var ref = (0,react.useState)(false), modalOpen = ref[0], changeModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), errorModalOpen = ref1[0], changeErrorModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), consent = ref2[0], changeConsent = ref2[1];
    var ref3 = (0,react.useState)({}), formData = ref3[0], changeFormData = ref3[1];
    var ref4 = (0,react.useState)({}), errors = ref4[0], changeErrors = ref4[1];
    var ref5 = (0,react.useState)(false), sending = ref5[0], changeSending = ref5[1];
    var ref6 = (0,react.useState)(null), linkedInCookie = ref6[0], setLinkedInCookie = ref6[1];
    (0,react.useEffect)(function() {
        setLinkedInCookie(localStorage.getItem("li_fat_id"));
    }, []);
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = (0,formAttribution/* formAttribution */.e)(type === "report" ? "Data Discovery Report Request" : type === "contact" ? "Contact Form" : "Demo Request Form");
        data.fields.forEach(function(field) {
            preparedData[field.id] = formData[field.id];
        });
        return preparedData;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!((0,form_functions/* validate */.G)({
                            type: type,
                            formData: formData,
                            data: data,
                            changeErrors: changeErrors,
                            consent: consent
                        }) === true)) {
                            _ctx.next = 18;
                            break;
                        }
                        changeSending(true);
                        dataToSend = {
                            type: type,
                            formValues: preparedData()
                        };
                        linkedInCookie && (0,userTracking.sendLinkedInConversion)();
                        if (type === "contact") {
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Contact"
                            }, formData.email);
                        }
                        if (type === "request") {
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Request Demo"
                            }, formData.email);
                        }
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 10:
                        changeModalOpen(true);
                        changeSending(false);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](7);
                        changeErrorModalOpen(true);
                        changeSending(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    14
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var newFormData = {};
        data.fields.forEach(function(field) {
            newFormData[field.id] = "";
        });
        changeFormData(newFormData);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return changeModalOpen(false);
                }
            }),
            errorModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return changeErrorModalOpen(false);
                },
                type: "Error",
                fromContact: true
            }),
            [
                "contact",
                "request"
            ].includes(type) && typeof formData[data.fields[0].id] !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
                data: data,
                formData: formData,
                changeData: changeData,
                errors: errors,
                consent: consent,
                className: className,
                changeConsent: changeConsent,
                handleSubmit: handleSubmit,
                sending: sending,
                type: type
            })
        ]
    });
};
var DiscoveryFormTemplate = function(param) {
    var dataSources = param.dataSources, data = param.data, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("LandingHero-background", "LandingHero-background-purple", "DiscoveryFormTemplate", "DiscoveryFormTemplate-WithCarousel"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingSourceCarousel/* LandingSourceCarousel */.g, {
                backgroundColor: "teal",
                data: dataSources
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("DiscoveryFormTemplate", "DiscoveryFormTemplate-WithCarousel", "LandingHero", "LandingHero-align-left", "LandingHero-type-platform-sign-up"),
                id: "hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "section-layout",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "LandingHero-title",
                                children: type === "request" ? "See it for yourself" : "Get in touch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "LandingHero-subtitle",
                                children: type === "request" ? "Meet our sales and solution consultants to learn how our product helps enterprises unlock the power of external data." : "Have a question or need more information about Demyst? Please enter your information and describe your inquiry, and someone will get back to you as soon as they can."
                            }),
                            type === "contact" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "LandingHero-subtitle",
                                children: [
                                    "Looking to apply to Demyst? Visit our",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: linksConstants/* linksConstants.CAREERS */.s.CAREERS,
                                        children: "careers page"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "section-layout",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoveryForm, {
                            data: data,
                            type: type
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/contact.jsx





var ContactPage = function(param) {
    var allDataSources = param.allDataSources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/contact",
                title: meta/* meta.contact.title */.$.contact.title,
                description: meta/* meta.contact.description */.$.contact.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoveryFormTemplate, {
                type: "contact",
                dataSources: allDataSources,
                data: contact,
                headerColor: contact.headerColor
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_contact = (ContactPage);


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 96615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LandingSourceCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var LandingSourceCarousel = function(param) {
    var data = param.data, options = param.options;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "LandingSourceCarousel-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                className: "LandingSourceCarousel"
            }, options), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "LandingSourceCarousel-sources-wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "LandingSourceCarousel-sources",
                        children: data === null || data === void 0 ? void 0 : data.filter(function(s) {
                            return s.logo;
                        }).map(function(source) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "LandingSourceCarousel-source",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: source.logo,
                                        alt: source.name,
                                        height: "64",
                                        width: "64",
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: source.name
                                    })
                                ]
                            }, source.name);
                        })
                    })
                })
            }))
        })
    });
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 17609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TermsCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var TermsCheckbox = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text, error = param.error, _classNameForText = param.classNameForText, classNameForText = _classNameForText === void 0 ? "terms_checkbox-text" : _classNameForText, _classNameMain = param.classNameMain, classNameMain = _classNameMain === void 0 ? "terms_checkbox-main" : _classNameMain, _classNameContainer = param.classNameContainer, classNameContainer = _classNameContainer === void 0 ? "terms_checkbox-container" : _classNameContainer, _classNameError = param.classNameError, classNameError = _classNameError === void 0 ? "terms_checkbox-error" : _classNameError;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classNameMain,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "terms_checkbox-label",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classNameContainer,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "checkbox",
                                value: text,
                                checked: checked,
                                onChange: function() {
                                    return onChange(!checked);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "terms_checkbox-box"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: classNameForText,
                        children: [
                            text.beginning,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link1_url,
                                    children: text.link1_text
                                })
                            }),
                            text.separator,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link2_url,
                                    children: text.link2_text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classNameError,
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formAttribution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var formAttribution = function(body) {
    var landingPage = localStorage.getItem("landing_page");
    var landingPageDatetime = localStorage.getItem("landing_page_datetime");
    var landingPageFullUrl = localStorage.getItem("landing_page_full_url");
    var currentPagePath = localStorage.getItem("current_page_path");
    var currentPagePathDatetime = localStorage.getItem("current_page_path_datetime");
    var prevPagePath = localStorage.getItem("prev_page_path");
    var prevPagePathDatetime = localStorage.getItem("prev_page_path_datetime");
    var pageFlow = JSON.parse(localStorage.getItem("page_flow"));
    var sessionPageFlow = JSON.parse(sessionStorage.getItem("session_page_flow"));
    var gaAdCookie = localStorage.getItem("gaAd");
    var gaAdCookieUpdated = localStorage.getItem("gaAd_updated");
    var gaAdCookieCreated = localStorage.getItem("gaAd_created");
    var isProductKickingAss = (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/external-data/")) || (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/third-party-data/"));
    var googleAdsGclid = localStorage.getItem("gclid");
    var googleAdsGclidCreated = localStorage.getItem("gclid_created");
    var googleAdsGclidUpdated = localStorage.getItem("gclid_updated");
    var linkedInCookie = localStorage.getItem("li_fat_id");
    var linkedInCookieCreated = localStorage.getItem("li_fat_id_created");
    var linkedInCookieUpdated = localStorage.getItem("li_fat_id_updated");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmMediumCreated = localStorage.getItem("utm_medium_created");
    var utmMediumUpdated = localStorage.getItem("utm_medium_updated");
    var utmSource = localStorage.getItem("utm_source");
    var utmSourceCreated = localStorage.getItem("utm_source_created");
    var utmSourceUpdated = localStorage.getItem("utm_source_updated");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var utmCampaignCreated = localStorage.getItem("utm_campaign_created");
    var utmCampaignUpdated = localStorage.getItem("utm_campaign_updated");
    var utmContent = localStorage.getItem("utm_content");
    var utmContentCreated = localStorage.getItem("utm_content_created");
    var utmContentUpdated = localStorage.getItem("utm_content_updated");
    var utmTerm = localStorage.getItem("utm_term");
    var utmTermCreated = localStorage.getItem("utm_term_created");
    var utmTermUpdated = localStorage.getItem("utm_term_updated");
    var marketingSource = linkedInCookie ? "linkedin" : googleAdsGclid ? "google(cpc)" : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        body: body
    }, landingPage && {
        landing_page: landingPage
    }, landingPageFullUrl && {
        landing_page_full_url: landingPageFullUrl
    }, landingPageDatetime && {
        landing_page_datetime: landingPageDatetime
    }, currentPagePath && {
        current_page_path: currentPagePath
    }, currentPagePathDatetime && {
        current_page_path_datetime: currentPagePathDatetime
    }, prevPagePath && {
        prev_page_path: prevPagePath
    }, prevPagePathDatetime && {
        prev_page_path_datetime: prevPagePathDatetime
    }, sessionPageFlow && {
        session_page_flow: sessionPageFlow
    }, pageFlow && {
        macro_page_flow: pageFlow
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmMediumCreated && {
        utm_medium_created: utmMediumCreated
    }, utmMediumUpdated && {
        utm_medium_updated: utmMediumUpdated
    }, utmSource && {
        utm_source: utmSource
    }, utmSourceCreated && {
        utm_source_created: utmSourceCreated
    }, utmSourceUpdated && {
        utm_source_updated: utmSourceUpdated
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmCampaignCreated && {
        utm_campaign_created: utmCampaignCreated
    }, utmCampaignUpdated && {
        utm_campaign_updated: utmCampaignUpdated
    }, utmContent && {
        utm_content: utmContent
    }, utmContentCreated && {
        utm_content_created: utmContentCreated
    }, utmContentUpdated && {
        utm_content_updated: utmContentUpdated
    }, utmTerm && {
        utm_term: utmTerm
    }, utmTermCreated && {
        utm_term_created: utmTermCreated
    }, utmTermUpdated && {
        utm_term_updated: utmTermUpdated
    }, marketingSource && {
        marketing_source: marketingSource
    }, gaAdCookie && {
        gaAd: gaAdCookie
    }, gaAdCookieCreated && {
        gaAd_created: gaAdCookieCreated
    }, gaAdCookieUpdated && {
        gaAd_updated: gaAdCookieUpdated
    }, isProductKickingAss && {
        pikYa: isProductKickingAss
    }, googleAdsGclid && {
        gclid: googleAdsGclid
    }, googleAdsGclidCreated && {
        gclid_created: googleAdsGclidCreated
    }, googleAdsGclidUpdated && {
        gclid_updated: googleAdsGclidUpdated
    }, linkedInCookie && {
        li_fat_id: linkedInCookie
    }, linkedInCookieCreated && {
        li_fat_id_created: linkedInCookieCreated
    }, linkedInCookieUpdated && {
        li_fat_id_updated: linkedInCookieUpdated
    }, document.referrer && {
        referrer: document.referrer
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2777,8540,9774,2888,179], function() { return __webpack_exec__(78367); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);